module.exports = __webpack_public_path__ + "img/logo_long_nm.8ab68f10.png";